import { Outlet } from "react-router-dom";
import { useAtomValue } from "jotai";
import { isNewQuestionnaireAtom, languageQuestionAtom } from "../jotai-atoms";
import classNames from "classnames";
import { TopBar } from "../components/organisms";
import { useGlobalNetworkToast } from "../hooks";

export const App = () => {
  const showIsNewQuestionnaire = useAtomValue(isNewQuestionnaireAtom);
  const languageQuestion = useAtomValue(languageQuestionAtom);

  // Add global network toast hook at the root level
  useGlobalNetworkToast();

  return (
    <div
      className={classNames("min-h-screen", {
        "bg-no-repeat bg-cover bg-dark-blue-gradient": showIsNewQuestionnaire,
      })}
    >
      {!showIsNewQuestionnaire && (
        <TopBar languageQuestion={languageQuestion} />
      )}
      <main>
        <Outlet />
      </main>
    </div>
  );
};
